import { Field, FieldProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { format } from 'date-fns';
import { DATE_FORMAT } from '../../lib/date_time';
import { TextField, TextFieldProps } from '@mui/material';
import { useUserConfiguration } from '../../providers/UserConfigurationProvider';

interface CommonTextFieldProps {
  name: string;
  fullWidth?: boolean;
  helperText?: string;
  noLabel?: boolean;
  variant?: 'outlined' | 'standard' | 'filled';
  minDate?: boolean;
  maxDate?: boolean;
  width?: number;
  dateString?: string;
  minDateFormated?: string;
  linkName?: string;
  endDateString?: string;
  readOnly?: boolean;
  isClearButton?: boolean;
  isTouchedOn?: boolean;
  smallPadding?: boolean;
}

export function CommonDateField(props: CommonTextFieldProps & TextFieldProps) {
  const { globalDateFormat } = useUserConfiguration();
  const { t } = useTranslation();
  const {
    name,
    noLabel = false,
    disabled,
    minDate = false,
    helperText = undefined,
    fullWidth = false,
    variant = 'standard',
    dateString, //for minDate String
    endDateString = 'endDate', //for endDate String
    maxDate = false,
    readOnly = false,
    isClearButton = false,
    isTouchedOn = false,
    linkName = '',
    minDateFormated = '',
    smallPadding = false,
  } = props;

  const nameSplit = name.split('.');
  const label = nameSplit[nameSplit.length - 1];

  return (
    <Field name={name}>
      {({ field, form, meta }: FieldProps) => {
        return (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              componentsProps={
                isClearButton
                  ? {
                      actionBar: {
                        actions: ['clear'],
                      },
                    }
                  : undefined
              }
              value={field.value}
              label={noLabel ? undefined : t(`attributes.${label}`)}
              readOnly={readOnly}
              onChange={(newValue) => {
                if (newValue) {
                  const formatDate = format(new Date(newValue), DATE_FORMAT);
                  form.setFieldValue(name, formatDate);
                  if (
                    linkName != '' &&
                    name == 'date' &&
                    linkName == 'alternateGenerateDate'
                  )
                    form.setFieldValue(linkName, '');
                } else if (newValue == null) {
                  form.setFieldValue(name, '');
                  if (linkName != '' && name.includes('startExceptionDate'))
                    form.setFieldValue(linkName, '');
                }
              }}
              inputFormat={globalDateFormat.split(' ')[0]}
              disabled={disabled}
              minDate={
                minDate
                  ? minDateFormated != ''
                    ? new Date(minDateFormated)
                    : new Date()
                  : form.getFieldProps(`${dateString}`).value
              }
              maxDate={
                maxDate
                  ? form.getFieldProps(`${endDateString}`).value
                  : undefined
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...field}
                  id="date"
                  variant={variant}
                  error={(meta.touched || isTouchedOn) && Boolean(meta.error)}
                  helperText={
                    helperText || ((meta.touched || isTouchedOn) && meta.error)
                  }
                  placeholder={globalDateFormat.split(' ')[0]}
                  value={
                    field.value &&
                    typeof field.value === 'string' &&
                    format(
                      new Date(field.value),
                      globalDateFormat.split(' ')[0],
                    )
                  }
                  inputProps={{
                    readOnly: true,
                    style: smallPadding ? { padding: '0.25rem' } : undefined,
                  }}
                  size="small"
                  fullWidth={fullWidth}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </LocalizationProvider>
        );
      }}
    </Field>
  );
}
